import { useState } from "react";
import { useTranslation } from "react-i18next";
import HowItWorksPanel from "./HowItWorksPanel";

/**
 * Bouton "Comprendre cette page" à placer à droite des en-têtes de page, via la
 * prop `helpButton` de `PageHeader`. Porte l'ouverture du panneau explicatif.
 */
const HowItWorksButton = ({ topic, context }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="page-header-pill"
        onClick={() => setIsOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
      >
        <i className="fas fa-question-circle" aria-hidden />
        <span>{t("howItWorks.buttonLabel")}</span>
      </button>
      <HowItWorksPanel
        topic={topic}
        context={context}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default HowItWorksButton;
